import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants"

export const STATION_WARNING_SOURCES: any = {
    default: 'Mausam IMD',
    sourceList: [
        {
            sourceName: 'Mausam IMD'
        }
    ]
}

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
export const STATIONWARNING_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        // 'State Boundary': {
        //     source: 'INDIA',
        //     displayName: 'State',
        //     name: 'State Boundary',
        //     visible: true,
        //     // hasLegend: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
        //     layer_name: 'State Boundary',
        //     layeroptions_pane: 'depth',
        //     // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.VECTOR_LAYER,
        //     type: LAYER_TYPES.VECTOR_LAYER,
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
        //     crs: 'EPSG4326',
        //     hasLables: true,
        //     applycql_filter: true,
        //     legendName: 'THUNDERSTORM_LEGEND',
        //     layeroptions_protocol: 'WFS'
        // },
        // 'State Boundaries': {
        //     source: 'INDIA',
        //     displayName: 'State Boundaries',
        //     name: 'State Boundaries',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
        //     layer_name: 'State Boundaries',
        //     layeroptions_pane: 'depth',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
        //     type: LAYER_TYPES.GEOJSON_LAYER,
        //     cql_filter_value: 'UUID',
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     onEachFeature: 'handleAdminPolygons',
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     layeroptions_protocol: 'WFS'
        // },
        // 'District Boundaries': {
        //     source: 'INDIA',
        //     displayName: 'District Boundaries',
        //     name: 'District Boundaries',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
        //     layer_name: 'District Boundaries',
        //     layeroptions_pane: 'max',
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
        //     type: LAYER_TYPES.GEOJSON_LAYER,
        //     cql_filter_value: 'UUID',
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     onEachFeature: 'handleAdminPolygons',
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     layeroptions_protocol: 'WFS'
        // },
        // 'District Boundary': {
        //     source: 'INDIA',
        //     displayName: 'District',
        //     name: 'District Boundary',
        //     visible: true,
        //     // hasLegend: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
        //     layer_name: 'District Boundary',
        //     layeroptions_pane: 'district',
        //     // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.VECTOR_LAYER,
        //     type: LAYER_TYPES.VECTOR_LAYER,
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
        //     crs: 'EPSG4326',
        //     hasLables: true,
        //     applycql_filter: true,
        //     legendName: 'THUNDERSTORM_LEGEND',
        //     layeroptions_protocol: 'WFS'
        // },
        // 'Block Boundary': {
        //     source: 'INDIA',
        //     displayName: 'Block',
        //     name: 'Block Boundary',
        //     visible: true,
        //     view: AgricultureMapConstants.VIEWS.ADMIN,
        //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
        //     layerptions_show_on_selector: false,
        //     layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
        //     layer_name: 'Block Boundary',
        //     layeroptions_pane: 'state',
        //     // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
        //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
        //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
        //     group: 'boundaries',
        //     group_type: 'radio-deselect',
        //     layerServiceType: LAYER_TYPES.VECTOR_LAYER,
        //     type: LAYER_TYPES.VECTOR_LAYER,
        //     cql_filter_value: null,
        //     cql_filter: null,
        //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
        //     environment_server_url: 'COMMON_GEOSERVER_URL',
        //     // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
        //     crs: 'EPSG4326',
        //     hasLables: true,
        //     applycql_filter: true,
        //     legendName: 'THUNDERSTORM_LEGEND',
        //     layeroptions_protocol: 'WFS'
        // },
        'State Boundary Labels': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
            legendName: 'STATIONWARNING_LEGEND',
            crs: 'EPSG4326',
        },
        'District Boundary Labels': {
            source: 'INDIA',
            displayName: 'District Boundary Labels',
            name: 'District Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'State_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
        },
        'Block Boundary Labels': {
            source: 'INDIA',
            displayName: 'Block Boundary Labels',
            name: 'Block Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Boundary Labels',
            layeroptions_pane: 'block',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN - 4,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'Dist_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
        },
    }
}

export const STATIONWARNING_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        STATIONWARNING_LEGEND: {
            // "Units": "mm/hr ",
            colorValues: [
                {
                  backgroundColor: '#fa403c',
                  textColor: '#ffffff',
                  text: 'Warning'
                },
                {
                  backgroundColor: '#fea73c',
                  textColor: '#ffffff',
                  text: 'Alert'
                },
                {
                  backgroundColor: '#ffcc3a',
                  textColor: '#ffffff',
                  text: 'Watch'
                },
                {
                  backgroundColor: '#338005',
                  textColor: '#ffffff',
                  text: 'No Warning'
                }
              ]
        }
    }
}